/**
 * Client-only hint that this browser previously held a Suturia account cache.
 * Used to avoid flashing the public landing while auth.bootstrap loads for
 * returning users. Anonymous / PageSpeed visits have no hint → show landing
 * immediately instead of BootSplash.
 */
import { KEY_ACCOUNT } from '@/lib/persistence';

export function likelyReturningAccount(): boolean {
  try {
    return Boolean(localStorage.getItem(KEY_ACCOUNT));
  } catch {
    return false;
  }
}
